/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Match_Female16Inputs */

const en__field_enum_icsrm_match_female16 = /** @type {(inputs: _Field_Enum_Icsrm_Match_Female16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woman`)
};

const de__field_enum_icsrm_match_female16 = /** @type {(inputs: _Field_Enum_Icsrm_Match_Female16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frau`)
};

/**
* | output |
* | --- |
* | "Woman" |
*
* @param {_Field_Enum_Icsrm_Match_Female16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_match_female16 = /** @type {((inputs?: _Field_Enum_Icsrm_Match_Female16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Match_Female16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_match_female16(inputs)
	return de__field_enum_icsrm_match_female16(inputs)
});
export { _field_enum_icsrm_match_female16 as "_field_enum_ICSRM_MATCH_FEMALE" }